import AccountActionPage from '@/components/auth/AccountAction'
import SubscriptionPendingContainer from '@/checkout/components/post-checkout/SubscriptionPendingContainer'
import PasswordResetPage from '@/routes/password/PasswordResetPage'
import SignInPage from '@/routes/sign-in/SignInPage'
import SignUpPage from '@/routes/sign-up/SignUpPage'
import InvitePage from '@/routes/invite/InvitePage'
import type { RouteFactory } from '@/routing/types'
import PostSignupPhonePage from '@/routes/complete-signup/PostSignupPhonePage'
import AuthSignInPage from '@/auth/components/SignInPage'
import CreateAccountPage from '@/auth/components/CreateAccountPage'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'

/**
 * Creates authentication-related routes.
 */
export const createAuthRoutes: RouteFactory = () => {
  const showRefreshedAuthPages = kGetFeatureFlagStatus(kFeatureFlags.ONBOARDING_REFRESH_AUTH_PAGES)

  return [
    {
      path: 'sign-in',
      element: showRefreshedAuthPages ? <AuthSignInPage /> : <SignInPage />,
    },
    {
      path: 'sign-up',
      element: showRefreshedAuthPages ? <CreateAccountPage /> : <SignUpPage />,
    },
    {
      path: 'forgot-password',
      element: <PasswordResetPage />,
    },
    {
      path: 'invite/:inviteId?',
      element: <InvitePage />,
    },
    {
      path: 'account-action',
      element: <AccountActionPage />,
    },
    {
      path: 'pending-subscription',
      element: <SubscriptionPendingContainer />,
    },
    {
      path: 'complete-signup/phone',
      element: <PostSignupPhonePage />,
    },
  ]
}
